export function applySiteMeta(info) {
  if (!info || typeof info !== "object") return;
  if (info.websiteName) {
    document.title = info.websiteName;
  }
  if (info.faviconImg) {
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = info.faviconImg;
  }
}
